import api from "./api";

const getMaterials = async () => {

    const response = await api.get("/api/materials");

    return response.data.data;

};

const addMaterial = async(formData)=>{
    const response = await api.post(
        "/api/material",
        formData
    );

    return response.data;

}

const updateMaterial = async(id,formData)=>{

    const response = await api.put(
        `/api/materials/${id}`,
        formData
    );

    return response.data;

}

const deleteMaterial = async(id)=>{

    const response = await api.delete(`/api/materials/${id}`);

    return response.data;

}

export default{
    getMaterials,
    addMaterial,
    updateMaterial,
    deleteMaterial
}